import React, { useContext, useReducer, createContext, useMemo } from 'react';
import produce from 'immer';
import { FormProvider, useForm } from 'react-hook-form';
import { getParticipantSchema } from 'components/Editor/Sidebar/Contents/Configuration/ParticipantList'
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup'


const FrontDeskStateContext = createContext();
const FrontDeskDispatchContext = createContext();

export const CHANGE_TAB = 'CHANGE_NAME';
export const RESET = 'RESET';
export const SET_CONTRACT = 'SET_CONTRACT';
export const SET_TEMPLATE = 'SET_TEMPLATE';
export const SET_PREVIEW_MODE = 'SET_PREVIEW_MODE';
export const SET_DETAIL_OPEN = 'SET_DETAIL_OPEN';
export const TOGGLE_SET_DETAIL_OPEN = 'TOGGLE_SET_DETAIL_OPEN';
export const FILL_VAR = 'FILL_VAR';
export const SET_MODIFIED = 'SET_MODIFIED';
export const SET_SEARCH = 'SET_SEARCH';
export const UNSET_MODIFIED = 'UNSET_MODIFIED';
export const UPDATE_AGENDA_PROPERTIES = 'UPDATE_AGENDA_PROPERTIES';

const initialState = () => ({
    tab: 'templates',
    contractId: null,
    templateId: null,
    preview_mode: false,
    isContractDetailOpen: false,
    contract: {},
    isModified: false,
    search: ''
});

const reducer = produce((draft, action) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
        case SET_MODIFIED:
            draft.isModified = action.isModified;
            break
        case UNSET_MODIFIED:
            draft.isModified = false;
            break
        case FILL_VAR:
            const apiName = action.variable.apiName;
            draft.isModified = true;
            draft.contract.participants.forEach((p) => {
                p.variables.forEach(v => {
                    if (v.apiName === apiName) {
                        v.value = action.variable.value;
                    }
                })
            })
            break;
        case SET_SEARCH:
            draft.search = action.search;
            break;
        case CHANGE_TAB:
            draft.tab = action.tab
            break;
        case SET_CONTRACT:
            draft.contract = action.contract;
            draft.contractId = action.contract?._id;
            draft.tab = 'contracts';
            draft.preview_mode = false;
            break;
        case UPDATE_AGENDA_PROPERTIES:
            const pariticipantIdx = draft.contract.participants.findIndex(p => p._id === action.participantId)
            draft.contract.participants[pariticipantIdx].agendaProperties = {
                ...(draft.contract.participants[pariticipantIdx].agendaProperties || {}),
                ...action.agendaProperties
            }
            break;
        case SET_TEMPLATE:
            draft.contract = {};
            draft.templateId = action.templateId;
            draft.questions = action.questions;
            draft.contractId = null;
            draft.preview_mode = false;
            break;
        case SET_PREVIEW_MODE:
            draft.preview_mode = action.preview_mode
            break;
        case SET_DETAIL_OPEN:
            draft.isContractDetailOpen = action.isContractDetailOpen;
            break;
        case TOGGLE_SET_DETAIL_OPEN:
            draft.isContractDetailOpen = !draft.isContractDetailOpen;
            break;
        case RESET:
            return initialState();
    }
}, {});

function getSchema({ contract }) {
    return Yup.object().shape({
        computedVariables: Yup.object().shape(contract?.participants?.reduce((obj, participant) => {
            participant.variables.map(variable => {
                obj[variable.apiName] = Yup.string().required('Required')
            })
            
            return obj
        }, {})),
        participants: Yup.array().of(getParticipantSchema({ validateAgendaProperties: true })),
        attachments: Yup.object().shape(contract?.participants?.reduce((obj, participant) => {
            participant.attachments?.filter(a => a.required)?.map(attachment => {
                obj[attachment._id] = Yup.string().required('Required')
            })
            
            console.log(obj)
            return obj
        }, {})),
    })
}

function FrontDeskProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState());

    const Schema = useMemo(() => {
        return getSchema({ 
            contract: state.contract
        })
    }, [state.contract])

    console.log(Schema)

    const methods = useForm({
         mode: 'onBlur',  
         resolver: yupResolver(Schema)
    });
    return (
        <FrontDeskStateContext.Provider value={{ ...state }}>
            <FrontDeskDispatchContext.Provider value={dispatch}>
                <FormProvider {...methods}>
                    {children}
                </FormProvider>
            </FrontDeskDispatchContext.Provider>
        </FrontDeskStateContext.Provider>
    )
}

function useFrontDeskState() {
    const context = useContext(FrontDeskStateContext)
    if (context === undefined) {
        throw new Error('useFrontDeskState must be used within a FrontDeskProvider')
    }
    return context
}

function useFrontDeskDispatch() {
    const context = useContext(FrontDeskDispatchContext)
    if (context === undefined) {
        throw new Error('useFrontDeskDispatch must be used within a FrontDeskProvider')
    }
    return context
}


function useFrontDesk() {
    return [useFrontDeskState(), useFrontDeskDispatch()]
}

export { FrontDeskProvider, useFrontDesk, useFrontDeskState, useFrontDeskDispatch }
